var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusinessOutline = function SvgBusinessOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8H4a1 1 0 00-1 1v10a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1zM8 6V4a2 2 0 012-2h4a2 2 0 012 2v2h4a3 3 0 013 3v10a3 3 0 01-3 3H4a3 3 0 01-3-3V9a3 3 0 013-3h4zm2 0h4V4h-4v2zM5 8h2v12H5V8zm12 0h2v12h-2V8z"
  })));
};
export default SvgBusinessOutline;